<script setup lang="ts">
import { computed } from 'vue';
import General from './components/General.vue';
import Location from './components/Location.vue';
import { can, useRouting } from '@/composables';
import { PERMISSIONS } from '@/enum/permissions';

const $routing = useRouting();

const organizationId = computed(() => Number($routing.route.params.id));
</script>

<template>
  <General v-if="can([PERMISSIONS.ORGANIZATION_SHOW])" :organization-id="organizationId" />
  <Location v-if="can([PERMISSIONS.ORGANIZATION_LOCATIONS_INDEX])" :organization-id="organizationId" />
</template>
